import React from 'react';
import UserForm from '../../../components/user/user-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userActions from '../../../actions/users';
import Loading from '../../../components/loading';
import AdminItemPageContainer from '../admin-item-page-container';

class UserContainer extends AdminItemPageContainer {

    getBaseUrl() {
        return '/admin/users';
    }

    fetchItem(id) {
        return this.props.actions.fetchUser(id);
    }

    render() {
        const {actions, loading} = this.props;

        return (
            <div className="panel">
                <header className="panel-header">User edit</header>
                <div className="panel-body">
                    {loading
                        ? <Loading/>
                        : <UserForm submit={actions.submitUser} onSuccessSubmit={this.onSuccessSubmit.bind(this)}></UserForm>
}
                </div>
            </div>
        )
    }
}

export default connect(function(state) {
    return {loading: state.admin.users.loading};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...userActions
        }, dispatch)
    };
})(UserContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/users/user-container.js